import React, { useEffect, useState, useRef } from "react";
import {
  Modal,
  Layout,
  Button,
  Form,
  Typography,
  Row,
  Col,
  Input,
  Card,
  Collapse,
} from "antd";
import { EyeOutlined } from "@ant-design/icons";
import WorkflowStepper from "../../../../components/patient/Enhancement/ECHS/WorkflowStepper";
import ViewDocumentEchs from "../../../../components/patient/Enhancement/ECHS/ViewDocumentEchs";
import CurrentCaseTracker from "../../../../components/patient/Enhancement/ECHS/CurrentCaseTracker";
import HistoryList from "../../../../components/patient/Enhancement/ECHS/HistoryList";
import UploadJustification from "../../../../components/patient/Enhancement/ECHS/UploadJustification";
import QCReview from "../../../../components/patient/Enhancement/ECHS/QCReview";
import AnnexureUpload from "../../../../components/patient/Enhancement/ECHS/AnnexureUpload";
import FinalReview from "../../../../components/patient/Enhancement/ECHS/FinalReview";
import { AppDispatch, RootState } from "../../../../store/store";
import { useDispatch, useSelector } from "react-redux";
import {
  getDigitallySignedDocument,
  getUnlistedProcedure,
  submitUnlistedProcedure,
} from "../../../../apis/SchemeService/ECHS/echsService";
import {
  errorMessage,
  successMessage,
} from "../../../../utils/notificationUtils";
import {
  downloadDocument,
  getAllStarhealthDocumentsData,
} from "../../../../apis/patientService";
import { CheckCircleTwoTone, LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { Space } from "antd";
import { getDeficiencyQuestionData } from "../../../../models/patientSlice";
import { message } from "antd";

const { Content } = Layout;

enum WorkflowStep {
  UPLOAD = 0,
  QC_REVIEW = 1,
  ANNEXURE = 2,
  FINAL_REVIEW = 3,
}

interface INewUnlistedProcedureContainerProps {
  visible?: boolean;
  onCancel?: () => void;
  activeKey?: any;
}

const { Text, Title } = Typography;

const NewUnlistedProcedureContainer: React.FC<
  INewUnlistedProcedureContainerProps
> = ({ visible = false, onCancel, activeKey }) => {
  const [currentStep, setCurrentStep] = useState<any>(null);
  const [justificationFile, setJustificationFile] = useState<File | null>(null);
  const [annexureFile, setAnnexureFile] = useState<File | null>(null);
  const { patients } = useSelector((state: RootState) => state);
  const [documentName, setDocumentName] = useState("");
  const dispatch = useDispatch<AppDispatch>();
  const [uploadedDocuments, setUploadedDocuments] = useState<
    {
      documentUrl: string;
      documentType: string;
      documentLabelType: string;
      documentName: string;
      deficiencyCheckStatus: any;
      id: number;
    }[]
  >([]);
  const [unlistedProcedureGetResponse, setUnlistedProcedureGetResponse] =
    useState<any>(null);
  const [form] = Form.useForm();
  const [documentTypes, setDocumentTypes] = useState<any>([]);
  const [
    isLastUnlistedProcedureCompleted,
    setIsLastUnlistedProcedureCompleted,
  ] = useState<boolean>(false);
  const [isGettingProcedures, setIsGettingProcedures] =
    useState<boolean>(false);
  const [showUnsignedDocumentsModal, setShowUnsignedDocumentsModal] =
    useState<boolean>(false);
  const [unsignedDocumentsCount, setUnsignedDocumentsCount] =
    useState<number>(0);
  const [digitallySignedDocuments, setDigitallySignedDocuments] = useState<any>(
    [],
  );
  const [isFetchingDigitallySignedDocs, setIsFetchingDigitallySignedDocs] =
    useState<boolean>(false);
  const [isAllDigitallySignedModal, setIsAllDigitallySignedModal] =
    useState<boolean>(false);
  const [getAllUnlistedProcedures, setGetAllUnlistedProcedures] = useState<any>(
    [],
  );
  const [selectedUnlistedProcedure, setSelectedUnlistedProcedure] =
    useState<any>(null);
  const [selectedUnlistedProcedureOrder, setSelectedUnlistedProcedureOrder] =
    useState<number | null>(null);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [documentUrls, setDocumentUrls] = useState<any[]>([]);
  const [clickedActiveTab, setClickedActiveTab] = useState<any>();
  const [selectedDocument, setSelectedDocument] = useState<any>(null);
  const [sentToQCDocument, setSentToQCDocument] = useState<boolean>(false);
  const [sentToQCAnnexture, setSentToQCAnnexture] = useState<boolean>(false);
  const [isIntimating, setIsIntimating] = useState<boolean>(false);

  const [procedures, setProcedures] = useState<any>([
    {
      id: "1",
      step: "UPLOAD JUSTIFICATION LETTER",
      status: "active" as const,
      description: "Pending",
    },
    {
      id: "2",
      step: "QC REVIEW & SUBMIT TO PORTAL",
      status: "pending" as const,
      description: "Pending",
    },
    {
      id: "3",
      step: "ANNEXURE (DOWNLOAD/UPLOAD)",
      status: "pending" as const,
      description: "Pending",
    },
    // {
    //   id: "4",
    //   step: "ANNEXURE REVIEW & SUBMIT TO PORTAL",
    //   status: "pending" as const,
    //   description: "Pending",
    // },
  ]);
  const [isProcedureSubmitted, setIsProcedureSubmitted] =
    useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const handleViewUnlistedProcedure = (item: any, orderNumber: number) => {
    setSelectedUnlistedProcedure(item);
    setSelectedUnlistedProcedureOrder(orderNumber);
  };

  const handleCloseUnlistedProcedureView = () => {
    setSelectedUnlistedProcedure(null);
    setSelectedUnlistedProcedureOrder(null);
  };

  const handleOpen = (documentList: any, docType: any) => {
    setPreviewDocument(true);
    setDocumentUrls(documentList || []);
    setClickedActiveTab(docType);
  };

  const handleCancelPreview = () => {
    setPreviewDocument(false);
    setDocumentUrls([]);
    setClickedActiveTab(null);
    setSelectedDocument(null);
  };

  const calculateTotalCost = (procedures: any[] = []) =>
    procedures?.reduce((sum: number, proc: any) => sum + (proc?.cost || 0), 0);

  const isStepVisible = (step: WorkflowStep): boolean => currentStep === step;

  const handleNextStep = () => {
    if (currentStep !== null && currentStep < WorkflowStep.FINAL_REVIEW) {
      setCurrentStep((currentStep + 1) as WorkflowStep);
    }
  };

  const handlePreviousStep = () => {
    if (currentStep !== null && currentStep > WorkflowStep.UPLOAD) {
      setCurrentStep((currentStep - 1) as WorkflowStep);
    }
  };

  const handleModalClose = () => {
    setCurrentStep(null);
    onCancel?.();
  };

  const handleStartWorkflow = () => {
    setCurrentStep(WorkflowStep.UPLOAD);
    form.resetFields();
    setUploadedDocuments([]);
    setJustificationFile(null);
    setAnnexureFile(null);
    setUnlistedProcedureGetResponse(null);
    setIsProcedureSubmitted(false);
    setIsSaving(false);
    setIsSubmitting(false);
    setProcedures([
      {
        id: "1",
        step: "UPLOAD JUSTIFICATION LETTER",
        status: "active" as const,
        description: "In progress",
      },
      {
        id: "2",
        step: "QC REVIEW & SUBMIT TO PORTAL",
        status: "pending" as const,
        description: "Pending",
      },
      {
        id: "3",
        step: "ANNEXURE (DOWNLOAD/UPLOAD)",
        status: "pending" as const,
        description: "Pending",
      },
      // {
      //   id: "4",
      //   step: "ANNEXURE REVIEW & SUBMIT TO PORTAL",
      //   status: "pending" as const,
      //   description: "Pending",
      // },
    ]);
  };

  const handleSubmit = async (initiated: boolean) => {
    try {
      if (initiated) {
        await form.validateFields();
      }
      const hasJustificationDoc = uploadedDocuments?.some((doc: any) =>
        doc?.documentLabelType?.toLowerCase()?.includes("justification"),
      );
      if (!hasJustificationDoc) {
        errorMessage("Please upload Justification letter before submitting.");
        return;
      }
      const values = await form.getFieldsValue(true);
      const updatedProcedureValues = values?.items?.map((value: any) => {
        // delete value?.["id"];
        return value;
      });
      const updatedValues = {
        caseId: patients?.fetchBasicDetails?.casesResponse?.id,
        visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        initiated,
        procedures: updatedProcedureValues,
        documentUrls: uploadedDocuments,
        remarks: values?.remarks,
      };

      if (initiated) {
        setIsSubmitting(true);
      } else {
        setIsSaving(true);
      }
      const res = await submitUnlistedProcedure(updatedValues);
      if (values?.initiated) {
        successMessage("Unlisted Procedure Initiated Successfully");
      } else {
        successMessage("Unlisted Procedure Saved Successfully");
      }
      handleGetUnlistedProcedures();
    } catch (err) {
      errorMessage("Please, Try again after sometime");
    } finally {
      setIsSaving(false);
      setIsSubmitting(false);
    }
  };

  const handleSentToQc = async () => {
    try {
      const hasJustificationDoc = uploadedDocuments?.some((doc: any) =>
        doc?.documentLabelType?.toLowerCase()?.includes("justification"),
      );
      if (!hasJustificationDoc) {
        errorMessage("Please upload Justification letter before submitting.");
        return;
      }
      const values = await form.getFieldsValue(true);
      const updatedProcedureValues = values?.items?.map((value: any) => {
        // delete value?.["id"];
        return value;
      });
      const updatedValues = {
        caseId: patients?.fetchBasicDetails?.casesResponse?.id,
        visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        initiated: false,
        sentToQCDocument: true,
        procedures: updatedProcedureValues,
        documentUrls: uploadedDocuments,
        remarks: values?.remarks,
      };

      setIsIntimating(true);
      const res = await submitUnlistedProcedure(updatedValues);

      successMessage("Unlisted Procedure Sent To Qc Successfully");
      handleGetUnlistedProcedures();
    } catch (err) {
      errorMessage("Please, Try again after sometime");
    } finally {
      setIsIntimating(false);
    }
  };

  const handleVerifyDigitallySignedAnnexure = async () => {
    try {
      const annextureDoc = uploadedDocuments?.find((doc: any) =>
        doc?.documentLabelType
          ?.toLowerCase()
          ?.includes("Annexture Document for Portal"?.toLowerCase()),
      );
      const payload = annextureDoc ? [annextureDoc] : [];

      const res = await getDigitallySignedDocument(payload);
      const results = res?.results || [];

      const unsigned = results.filter((doc: any) => !doc?.digitallySigned);

      if (unsigned?.length > 0) {
        setUnsignedDocumentsCount(unsigned.length);
        return false;
      } else {
        setUnsignedDocumentsCount(0);
        return true;
      }
    } catch (err: any) {
      errorMessage("Please try again later");
    }
  };

  useEffect(() => {
    const getAnnexure = async () => {
      const annextureDoc = uploadedDocuments?.some((doc: any) =>
        doc?.documentLabelType
          ?.toLowerCase()
          ?.includes("Annexture Document for Portal"?.toLowerCase()),
      );

      if (annextureDoc) {
        await handleVerifyDigitallySignedAnnexure();
      }
    };

    getAnnexure();
  }, [uploadedDocuments]);

  const handleVerifyDigitallySignedDocuments = async () => {
    setIsFetchingDigitallySignedDocs(true);

    try {
      const annextureDoc = uploadedDocuments?.find((doc: any) =>
        doc?.documentLabelType
          ?.toLowerCase()
          ?.includes("Annexture Document for Portal"?.toLowerCase()),
      );
      const payload = annextureDoc ? [annextureDoc] : [];

      const res = await getDigitallySignedDocument(payload);
      const results = res?.results || [];

      setDigitallySignedDocuments(results);

      const unsigned = results.filter((doc: any) => !doc?.digitallySigned);

      if (unsigned?.length > 0) {
        setUnsignedDocumentsCount(unsigned.length);
        setShowUnsignedDocumentsModal(true);
        return false;
      } else {
        setUnsignedDocumentsCount(0);
        setIsAllDigitallySignedModal(true);
        return true;
      }
    } catch (err: any) {
      errorMessage("Please try again later");
    } finally {
      setIsFetchingDigitallySignedDocs(false);
    }
  };

  const handleSubmitAnnexure = async (initiated: boolean) => {
    try {
      const hasAnnextureDoc = uploadedDocuments?.some((doc: any) =>
        doc?.documentLabelType
          ?.toLowerCase()
          ?.includes("Annexture Document for Portal"?.toLowerCase()),
      );
      if (!hasAnnextureDoc) {
        errorMessage(
          "Please upload Digitally Signed Annexture letter before submitting.",
        );
        return;
      }

      const isDigitallySigned = await handleVerifyDigitallySignedDocuments();
      if (!isDigitallySigned) {
        errorMessage(
          "Please upload Digitally Signed Annexture letter before submitting.",
        );
        return;
      }

      const updatedValues = {
        caseId: patients?.fetchBasicDetails?.casesResponse?.id,
        visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        initiated: unlistedProcedureGetResponse?.initiated,
        procedures: unlistedProcedureGetResponse?.procedures,
        documentUrls: uploadedDocuments,
        remarks: unlistedProcedureGetResponse?.remarks,
        annextureUploaded: true,
        annextureSubmittedOnPortal: initiated,
      };

      if (initiated) {
        setIsSubmitting(true);
      } else {
        setIsSaving(true);
      }
      const res = await submitUnlistedProcedure(updatedValues);
      if (unlistedProcedureGetResponse?.initiated) {
        successMessage("Annexture Letter Initiated Successfully");
      } else {
        successMessage("Annexture Letter Saved Successfully");
      }
      handleGetUnlistedProcedures();
    } catch (err) {
      errorMessage("Please, Try again after sometime");
    } finally {
      setIsSaving(false);
      setIsSubmitting(false);
    }
  };

  const handleManualSubmitAnnexure = async (documentData: any) => {
    try {
      const updatedValues = {
        caseId: patients?.fetchBasicDetails?.casesResponse?.id,
        visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        initiated: unlistedProcedureGetResponse?.initiated,
        procedures: unlistedProcedureGetResponse?.procedures,
        documentUrls: [...uploadedDocuments, documentData],
        remarks: unlistedProcedureGetResponse?.remarks,
        annextureUploaded: false,
        annextureSubmittedOnPortal: false,
      };

      setIsSaving(true);
      const res = await submitUnlistedProcedure(updatedValues);
      if (unlistedProcedureGetResponse?.initiated) {
        successMessage("Annexture Letter Initiated Successfully");
      } else {
        successMessage("Annexture Letter Saved Successfully");
      }
      handleGetUnlistedProcedures();
    } catch (err) {
      errorMessage("Please, Try again after sometime");
    } finally {
      setIsSaving(false);
      setIsSubmitting(false);
    }
  };

  const handleSentToQcAnnexure = async () => {
    try {
      const hasAnnextureDoc = uploadedDocuments?.some((doc: any) =>
        doc?.documentLabelType
          ?.toLowerCase()
          ?.includes("Annexture Document for Portal"?.toLowerCase()),
      );
      if (!hasAnnextureDoc) {
        errorMessage(
          "Please upload Digitally Signed Annexture letter before submitting.",
        );
        return;
      }

      const isDigitallySigned = await handleVerifyDigitallySignedDocuments();
      if (!isDigitallySigned) {
        errorMessage(
          "Please upload Digitally Signed Annexture letter before submitting.",
        );
        return;
      }

      const updatedValues = {
        caseId: patients?.fetchBasicDetails?.casesResponse?.id,
        visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        initiated: unlistedProcedureGetResponse?.initiated,
        procedures: unlistedProcedureGetResponse?.procedures,
        documentUrls: uploadedDocuments,
        remarks: unlistedProcedureGetResponse?.remarks,
        sentToQCDocument: unlistedProcedureGetResponse?.sentToQCDocument,
        sentToQCAnnexture: true,
        annextureUploaded: true,
        annextureSubmittedOnPortal: false,
      };
      setIsIntimating(true);
      const res = await submitUnlistedProcedure(updatedValues);

      successMessage("Annexture Letter Sent to QC Successfully");
      handleGetUnlistedProcedures();
    } catch (err) {
      errorMessage("Please, Try again after sometime");
    } finally {
      setIsIntimating(false);
    }
  };

  const groupDocumentsByType = (
    docs: {
      documentUrl: string;
      documentType: string;
      documentLabelType: string;
      documentName: string;
      deficiencyCheckStatus: any;
      id: number;
    }[],
  ) => {
    return docs?.reduce(
      (
        acc: Record<
          string,
          {
            documentUrl: string;
            documentType: string;
            documentLabelType: string;
            documentName: string;
            deficiencyCheckStatus: any;
            id: number;
          }[]
        >,
        doc,
      ) => {
        const type = doc.documentType;

        if (!acc[type]) {
          acc[type] = [];
        }

        acc[type].push(doc);

        return acc;
      },
      {},
    );
  };

  const handleGetUnlistedProcedures = async () => {
    try {
      setIsGettingProcedures(true);
      const res = await getUnlistedProcedure(
        patients?.fetchBasicDetails?.casesResponse?.id,
        patients?.fetchBasicDetails?.visitInfoResponse?.id,
      );
      setIsLastUnlistedProcedureCompleted(res?.[0]?.annextureSubmittedOnPortal);
      if (res?.length > 0) {
        setGetAllUnlistedProcedures(res);
        setUnlistedProcedureGetResponse(res?.[0]);
        setIsProcedureSubmitted(res?.[0]?.initiated);
        setSentToQCDocument(res?.[0]?.sentToQCDocument);
        setSentToQCAnnexture(res?.[0]?.sentToQCAnnexture);
        const hasDocs = res?.[0]?.documentUrls?.some((doc: any) =>
          doc?.documentLabelType?.toLowerCase()?.includes("justification"),
        );
        const hasProcedures = res?.[0]?.procedures?.length > 0;

        const isInitiated = res?.[0]?.initiated;
        const hasAnnexureDocs = res?.[0]?.annextureUploaded;

        const updatedSteps = [
          {
            id: "1",
            step: "UPLOAD JUSTIFICATION LETTER",
            status: hasDocs ? "completed" : "active",
            description: hasDocs ? "Completed" : "In progress",
          },
          {
            id: "2",
            step: "QC REVIEW & SUBMIT TO PORTAL",
            status: hasDocs
              ? hasProcedures && isInitiated
                ? "completed"
                : "active"
              : "pending",
            description: hasDocs
              ? hasProcedures && isInitiated
                ? "Completed"
                : "In progress"
              : "Pending",
          },
          {
            id: "3",
            step: "ANNEXURE (DOWNLOAD/UPLOAD)",
            status:
              hasAnnexureDocs &&
              unsignedDocumentsCount === 0 &&
              res?.[0]?.annextureSubmittedOnPortal
                ? "completed"
                : isInitiated
                  ? "active"
                  : "pending",
            description:
              hasAnnexureDocs &&
              unsignedDocumentsCount === 0 &&
              res?.[0]?.annextureSubmittedOnPortal
                ? "Completed"
                : isInitiated
                  ? "In progress"
                  : "Pending",
          },
          // {
          //   id: "4",
          //   step: "ANNEXURE REVIEW & SUBMIT TO PORTAL",
          //   status: res?.[0]?.annextureSubmittedOnPortal
          //     ? "completed"
          //     : hasAnnexureDocs
          //       ? "active"
          //       : "pending",
          //   description: res?.[0]?.annextureSubmittedOnPortal
          //     ? "Completed"
          //     : hasAnnexureDocs
          //       ? "In progress"
          //       : "Pending",
          // },
        ];

        setProcedures(updatedSteps);
        if (visible && currentStep === null && updatedSteps?.length > 0) {
          const firstPendingIdx = updatedSteps?.findIndex(
            (step: any) => step.status !== "completed",
          );
          if (firstPendingIdx !== -1) {
            setCurrentStep(firstPendingIdx);
          }
        }

        form.setFieldsValue({
          items:
            res?.[0]?.procedures?.map((proc: any) => ({
              ...proc,
              status: true,
            })) || [],
          remarks: res?.[0]?.remarks,
        });
        // setUploadedDocuments(groupDocumentsByType(res?.documentUrls || {}));
        setUploadedDocuments(res?.[0]?.documentUrls || []);
      }
    } catch (err) {
      errorMessage("Please, Try again later");
    } finally {
      setIsGettingProcedures(false);
    }
  };

  const fetchDocuments = async (
    schemeMetaDataId: number,
    caseId: number,
    visitId: number,
  ) => {
    try {
      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id
      ) {
        const AllDocumentList = await getAllStarhealthDocumentsData(
          caseId,
          visitId,
          schemeMetaDataId,
        );
        setDocumentTypes(AllDocumentList?.["Unlisted Procedures"]);
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
    }
  };

  useEffect(() => {
    if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
      fetchDocuments(
        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        patients?.fetchBasicDetails?.casesResponse?.id,
        patients?.fetchBasicDetails?.visitInfoResponse?.id,
      );
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    currentStep,
  ]);

  const fetchDeficiencyData = async (
    selectedDocument: any,
    selectedDocumentId: any,
  ) => {
    try {
      if (selectedDocumentId) {
        await dispatch(getDeficiencyQuestionData(selectedDocumentId));
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setSelectedDocument(null);
    }
  };

  const handleDeficiencyModalOpen = async (
    documentUrl: string,
    documentId: number,
    document: any,
  ) => {
    await fetchDeficiencyData(document, document?.id);
    // setDeficiencyModal(true);
    setSelectedDocument(document);
  };

  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      await downloadDocument(fileName, url);
      message.success("Document Downloaded successfully");
    } catch (error) {
      message.error("Download failed");
    }
  };

  useEffect(() => {
    if (currentStep === null) handleGetUnlistedProcedures();
  }, [currentStep]);

  const renderStepContent = () => {
    switch (currentStep) {
      case WorkflowStep.UPLOAD:
        return (
          <UploadJustification
            file={justificationFile}
            setFile={setJustificationFile}
            onNext={handleNextStep}
            onCancel={() => setCurrentStep(null)}
            uploadedDocuments={uploadedDocuments}
            setUploadedDocuments={setUploadedDocuments}
            caseInfo={{
              caseId:
                patients?.fetchBasicDetails?.visitInfoResponse?.creditNumber,
              patientName:
                patients?.fetchBasicDetails?.patientResponse?.fullName,
            }}
            handleSubmit={handleSubmit}
            documentTypes={documentTypes}
            activeKey={activeKey}
            groupDocumentsByType={groupDocumentsByType}
            isProcedureSubmitted={isProcedureSubmitted}
            isSaving={isSaving}
            sentToQCDocument={sentToQCDocument}
            handleSentToQc={handleSentToQc}
            isIntimating={isIntimating}
          />
        );
      case WorkflowStep.QC_REVIEW:
        return (
          <QCReview
            onNext={handleNextStep}
            onCancel={() => setCurrentStep((prev: any) => prev - 1)}
            caseInfo={{
              caseId:
                patients?.fetchBasicDetails?.visitInfoResponse?.creditNumber,
              patientName:
                patients?.fetchBasicDetails?.patientResponse?.fullName,
            }}
            form={form}
            uploadedDocuments={uploadedDocuments}
            setUploadedDocuments={setUploadedDocuments}
            documentTypes={documentTypes}
            activeKey={activeKey}
            groupDocumentsByType={groupDocumentsByType}
            handleSubmit={handleSubmit}
            isProcedureSubmitted={isProcedureSubmitted}
            isSaving={isSaving}
            isSubmitting={isSubmitting}
          />
        );
      case WorkflowStep.ANNEXURE:
        return (
          <AnnexureUpload
            file={annexureFile}
            setFile={setAnnexureFile}
            onNext={handleNextStep}
            onCancel={() => setCurrentStep((prev: any) => prev - 1)}
            documentTypes={documentTypes}
            activeKey={activeKey}
            groupDocumentsByType={groupDocumentsByType}
            uploadedDocuments={uploadedDocuments}
            setUploadedDocuments={setUploadedDocuments}
            handleSubmitAnnexure={handleSubmitAnnexure}
            handleManualSubmitAnnexure={handleManualSubmitAnnexure}
            isSaving={isSaving}
            unsignedDocumentsCount={unsignedDocumentsCount}
            isLastUnlistedProcedureCompleted={isLastUnlistedProcedureCompleted}
            isAnnextureUploaded={
              unlistedProcedureGetResponse?.annextureUploaded
            }
            sentToQCAnnexture={sentToQCAnnexture}
            handleSentToQcAnnexure={handleSentToQcAnnexure}
            isIntimating={isSubmitting}
          />
        );
      case WorkflowStep.FINAL_REVIEW:
        return (
          <FinalReview
            onSubmit={handleSubmit}
            onCancel={() => setCurrentStep(null)}
            onSaveDraft={handleSubmit}
            caseInfo={{
              caseId:
                patients?.fetchBasicDetails?.visitInfoResponse?.creditNumber,
              patientName:
                patients?.fetchBasicDetails?.patientResponse?.fullName,
            }}
            handleSubmitAnnexure={handleSubmitAnnexure}
            isSaving={isSaving}
            isSubmitting={isSubmitting}
            documentTypes={documentTypes}
            activeKey={activeKey}
            groupDocumentsByType={groupDocumentsByType}
            uploadedDocuments={uploadedDocuments}
            setUploadedDocuments={setUploadedDocuments}
            isLastUnlistedProcedureCompleted={isLastUnlistedProcedureCompleted}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Modal
        loading={isGettingProcedures}
        title={
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <span style={{ fontSize: 16, fontWeight: 700 }}>
              Unlisted Procedure
            </span>
            {currentStep === null ? (
              <span style={{ fontSize: 12, color: "gray" }}>
                Manage and track non-standard surgical/non surgical requests
              </span>
            ) : (
              <span style={{ fontSize: 12, color: "gray" }}>
                {patients?.fetchBasicDetails?.visitInfoResponse?.creditNumber} •
                PATIENT:{" "}
                {patients?.fetchBasicDetails?.patientResponse?.fullName} •
                CLAIM ID:{" "}
                {patients?.fetchBasicDetails?.visitInfoResponse?.claimId}
              </span>
            )}
          </div>
        }
        visible={visible}
        onCancel={handleModalClose}
        style={{
          top: 2,
          left: 4,
          padding: 0,
          maxWidth: "100vw",
          height: "148vh",
        }}
        width="100vw"
        footer={null}
        bodyStyle={{
          height: "134vh",
          overflowY: "scroll",
          padding: 0,
          overflowX: "hidden",
        }}
        wrapClassName="patient-list-table-modal"
      >
        <Layout style={{ padding: 0, background: "white" }}>
          {/* Dashboard View - when no step is active */}
          {currentStep === null ? (
            <>
              {!getAllUnlistedProcedures?.[0]?.annextureSubmittedOnPortal ? (
                <>
                  <span
                    style={{
                      color: "gray",
                      background: "white",
                      marginTop: 20,
                      marginBottom: 10,
                    }}
                  >
                    Current Workflow Tracking
                  </span>
                  <CurrentCaseTracker
                    caseId={
                      patients?.fetchBasicDetails?.visitInfoResponse
                        ?.creditNumber
                    }
                    procedures={procedures}
                    onStepClick={(step: number) => {
                      const hasJustificationDoc = uploadedDocuments?.some(
                        (doc: any) =>
                          doc?.documentLabelType
                            ?.toLowerCase()
                            ?.includes("justification"),
                      );
                      if (step === 1 && !hasJustificationDoc) {
                        errorMessage(
                          "Please upload at least one document before proceeding to QC Review.",
                        );
                        return;
                      } else if (step === 2 && !isProcedureSubmitted) {
                        errorMessage(
                          "Please, Submit Procedure before proceeding",
                        );
                        return;
                      } else if (step === 3 && unsignedDocumentsCount !== 0) {
                        errorMessage(
                          "Please, Upload Annexure Letter Digitally Signed",
                        );
                        return;
                      }
                      setCurrentStep(step as WorkflowStep);
                    }}
                  />
                </>
              ) : null}
              {/* <WorkflowStepper
              current={-1}
              onStepClick={(step: any) => setCurrentStep(step as WorkflowStep)}
            /> */}
              <Content style={{ marginTop: 14 }}>
                <HistoryList
                  onAddNew={handleStartWorkflow}
                  onViewItem={handleViewUnlistedProcedure}
                  isLastUnlistedProcedureCompleted={
                    isLastUnlistedProcedureCompleted
                  }
                  getAllUnlistedProcedures={getAllUnlistedProcedures}
                />
              </Content>
            </>
          ) : (
            <>
              {/* Workflow View - shows stepper and step content only */}
              <WorkflowStepper
                current={currentStep}
                onStepClick={(step: any) => {
                  const hasJustificationDoc = uploadedDocuments?.some(
                    (doc: any) =>
                      doc?.documentLabelType
                        ?.toLowerCase()
                        ?.includes("justification"),
                  );
                  if (step === 1 && !hasJustificationDoc) {
                    errorMessage(
                      "Please upload at least one document before proceeding to QC Review.",
                    );
                    return;
                  } else if (step === 2 && !isProcedureSubmitted) {
                    errorMessage("Please, Submit Procedure before proceeding");
                    return;
                  } else if (step === 3 && unsignedDocumentsCount !== 0) {
                    errorMessage(
                      "Please, Upload Annexure Letter Digitally Signed",
                    );
                    return;
                  }
                  if (step <= currentStep + 1) {
                    setCurrentStep(step as WorkflowStep);
                  }
                }}
              />
              <Content style={{ marginTop: 14 }}>{renderStepContent()}</Content>
            </>
          )}
          {currentStep === null ? (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                type="primary"
                onClick={handleModalClose}
                style={{
                  background: "#00549E",
                  color: "white",
                  width: 120,
                  marginTop: 10,
                }}
              >
                Close
              </Button>
            </div>
          ) : (
            <></>
          )}
        </Layout>
      </Modal>

      <Modal
        visible={!!selectedUnlistedProcedure}
        title={`Unlisted Procedure - ${selectedUnlistedProcedureOrder ?? ""}`}
        onCancel={handleCloseUnlistedProcedureView}
        footer={[
          <Button
            key="close"
            onClick={handleCloseUnlistedProcedureView}
            style={{ background: "#00549e", color: "white" }}
          >
            Close
          </Button>,
        ]}
        width={2000}
        centered
      >
        <Card
          className="unlistedprocedure-card"
          style={{ backgroundColor: "white", borderRadius: 16 }}
        >
          <Collapse defaultActiveKey={["1"]}>
            <Collapse.Panel header="Procedures" key="1">
              <Form layout="vertical">
                <div
                  style={{
                    maxHeight: "68vh",
                    overflowY: "auto",
                    padding: "8px 20px",
                  }}
                >
                  {selectedUnlistedProcedure?.procedures?.length > 0 ? (
                    selectedUnlistedProcedure?.procedures?.map(
                      (procedure: any, idx: number) => (
                        <Row
                          key={procedure?.id || idx}
                          gutter={[16, 16]}
                          align="top"
                          style={{
                            border: "1px solid #00549E",
                            padding: "10px 20px",
                            borderRadius: "16px",
                            marginBottom: "0.8rem",
                            background: "white",
                            boxShadow: "0px 2px 8px 0px #00000040",
                          }}
                        >
                          <Col span={8}>
                            <Form.Item
                              label="Procedure"
                              name={`procedureName-${idx}`}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                defaultValue={procedure?.procedureName}
                                disabled
                                style={{ color: "black" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={7}>
                            <Form.Item
                              label="Diagnosis/Reason"
                              name={`diagnosisReason-${idx}`}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                defaultValue={procedure?.diagnosisReason}
                                disabled
                                style={{ color: "black", borderRadius: "5px" }}
                              />
                            </Form.Item>
                          </Col>

                          <Col span={8}>
                            <Form.Item
                              label="Cost"
                              name={`cost-${idx}`}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                defaultValue={`₹${procedure?.cost ?? 0}`}
                                disabled
                                style={{ color: "black", borderRadius: "5px" }}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      ),
                    )
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: 120,
                      }}
                    >
                      NO PROCEDURE
                    </div>
                  )}
                </div>

                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Form.Item
                      label="Remarks"
                      name="remarks"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <Input
                        disabled
                        defaultValue={selectedUnlistedProcedure?.remarks}
                        style={{ color: "black" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      label="Total Procedures"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <Input
                        disabled
                        defaultValue={
                          selectedUnlistedProcedure?.procedures?.length ?? 0
                        }
                        style={{ color: "black" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      label="Total Cost"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <Input
                        disabled
                        defaultValue={`₹${calculateTotalCost(
                          selectedUnlistedProcedure?.procedures,
                        )}`}
                        style={{ color: "black" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Collapse.Panel>

            <Collapse.Panel header="Documents" key="2">
              {selectedUnlistedProcedure?.documentUrls?.length > 0 ? (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    gap: 10,
                  }}
                >
                  {selectedUnlistedProcedure?.documentUrls?.map((doc: any) => (
                    <div
                      key={doc?.id}
                      style={{
                        border: "1px solid #eee",
                        padding: 10,
                        borderRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        background: "#fafafa",
                      }}
                    >
                      <div style={{ flex: 1, marginRight: 10 }}>
                        <div style={{ fontWeight: 600 }}>
                          {doc?.documentName || "Untitled"}
                        </div>
                        <div style={{ color: "#595959", fontSize: 12 }}>
                          {doc?.documentLabelType || doc?.documentType}
                        </div>
                      </div>
                      <Button
                        type="link"
                        icon={<EyeOutlined />}
                        onClick={() =>
                          handleOpen(
                            selectedUnlistedProcedure?.documentUrls,
                            doc?.documentLabelType,
                          )
                        }
                      >
                        View
                      </Button>
                    </div>
                  ))}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: 120,
                  }}
                >
                  NO DOCUMENT UPLOADED
                </div>
              )}
            </Collapse.Panel>
          </Collapse>
        </Card>
      </Modal>

      <ViewDocumentEchs
        handleCancel={handleCancelPreview}
        open={previewDocument}
        handleDownloadDocument={handleDownloadDocument}
        documents={documentUrls}
        handleDeficiencyModal={handleDeficiencyModalOpen}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        setDocumentName={setDocumentName}
        selectedDocument={selectedDocument}
        clickedActiveTab={clickedActiveTab}
      />

      <Modal
        title="Document Signature Status"
        visible={showUnsignedDocumentsModal}
        onCancel={() => setShowUnsignedDocumentsModal(false)}
        footer={[
          <Button
            key="close"
            onClick={() => setShowUnsignedDocumentsModal(false)}
            style={{ background: "#00549e", color: "white" }}
          >
            Close
          </Button>,
        ]}
        centered
        width={700}
      >
        <div style={{ padding: "20px 0" }}>
          <p
            style={{
              fontSize: "16px",
              marginBottom: "20px",
              fontWeight: "bold",
              color: "#d32f2f",
            }}
          >
            {unsignedDocumentsCount} document(s) are NOT digitally signed
          </p>

          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            {/* Digitally Signed Documents */}
            {digitallySignedDocuments?.some(
              (doc: any) => doc?.digitallySigned,
            ) && (
              <div style={{ marginBottom: "20px" }}>
                <h4 style={{ color: "#2e7d32", marginBottom: "10px" }}>
                  ✓ Digitally Signed Documents
                </h4>
                {digitallySignedDocuments
                  ?.filter((doc: any) => doc?.digitallySigned)
                  ?.map((doc: any, index: number) => (
                    <div
                      key={index}
                      style={{
                        padding: "8px 12px",
                        backgroundColor: "#e8f5e9",
                        marginBottom: "8px",
                        borderRadius: "4px",
                        borderLeft: "4px solid #2e7d32",
                      }}
                    >
                      <span style={{ color: "#2e7d32", fontWeight: "500" }}>
                        ✓ {doc?.documentLabelType || doc?.documentName}
                      </span>
                    </div>
                  ))}
              </div>
            )}

            {/* Non-Digitally Signed Documents */}
            {digitallySignedDocuments?.some(
              (doc: any) => !doc?.digitallySigned,
            ) && (
              <div>
                <h4 style={{ color: "#d32f2f", marginBottom: "10px" }}>
                  ✗ Not Digitally Signed Documents
                </h4>
                {digitallySignedDocuments
                  ?.filter((doc: any) => !doc?.digitallySigned)
                  ?.map((doc: any, index: number) => (
                    <div
                      key={index}
                      style={{
                        padding: "8px 12px",
                        backgroundColor: "#ffebee",
                        marginBottom: "8px",
                        borderRadius: "4px",
                        borderLeft: "4px solid #d32f2f",
                      }}
                    >
                      <span style={{ color: "#d32f2f", fontWeight: "500" }}>
                        ✗ {doc?.documentLabelType || doc?.documentName}
                      </span>
                    </div>
                  ))}
              </div>
            )}
          </div>

          <p style={{ color: "#666", fontSize: "14px", marginTop: "20px" }}>
            Please ensure all documents are digitally signed before submitting.
          </p>
        </div>
      </Modal>

      <Modal
        open={isFetchingDigitallySignedDocs}
        footer={null}
        closable={false}
        maskClosable={false}
        centered
        width={820}
      >
        <div
          style={{
            textAlign: "center",
            padding: "56px 32px",
            backgroundColor: "#ffffff",
          }}
        >
          <Spin
            indicator={
              <LoadingOutlined
                style={{ fontSize: 48, color: "rgb(0, 76, 143)" }}
                spin
              />
            }
          />

          <Title
            level={4}
            style={{
              marginTop: 32,
              marginBottom: 12,
              color: "rgb(0, 76, 143)",
              fontWeight: 600,
            }}
          >
            Verifying Digital Signature
          </Title>

          <Text
            style={{
              color: "rgba(0, 0, 0, 0.65)",
              fontSize: 14,
              lineHeight: 1.6,
              maxWidth: 800,
              display: "inline-block",
            }}
          >
            We are currently validating the digitally signed document. Please
            keep this page open and avoid refreshing until the process is
            complete.
          </Text>
        </div>
      </Modal>

      <Modal
        open={isAllDigitallySignedModal}
        footer={null}
        closable={true}
        maskClosable={false}
        centered
        width={520}
        onCancel={() => setIsAllDigitallySignedModal(false)}
      >
        <div style={{ textAlign: "center", padding: "24px 12px" }}>
          <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: 56 }} />

          <Title level={4} style={{ marginTop: 24 }}>
            All Documents Are Digitally Signed
          </Title>

          <Text type="secondary">
            The digital signing process has been completed successfully. You may
            now continue to the next step.
          </Text>

          <Space
            size="middle"
            style={{
              marginTop: 32,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              onClick={() => setIsAllDigitallySignedModal(false)}
              style={{ background: "#00549e", color: "white" }}
            >
              Close
            </Button>

            {/* <Button
              type="primary"
              size="large"
              style={{ backgroundColor: "rgb(0, 76, 143)", color: "#fff" }}
              onClick={async () => {
                try {
                  await form.validateFields();
                  setIsAllDigitallySignedModal(false);
                  if (
                    patients?.fetchBasicDetails?.casesResponse
                      ?.integratedWithPortal
                  ) {
                    const casePreAuth = preAuth?.portalData?.casePreAuthEchs;
                    const referralResponse =
                      casePreAuth?.casePreAuthEchsReferralResponse;
                    const emergencyResponse =
                      casePreAuth?.casePreAuthEchsEmergencyResponse;
                    const claimId =
                      referralResponse?.claimId || emergencyResponse?.claimId;
                    if (claimId) {
                      setIsSubmitOnPortal(true);
                    } else {
                      setIsSubmittedOnPortal(true);
                    }
                  } else {
                    setManuallyClaimIdPortal(true);
                  }
                } catch (err: any) {
                  if (err?.errorFields) {
                    errorMessage(
                      "Please fill all required fields before submitting",
                    );
                  } else {
                    errorMessage("Please try again later");
                  }
                }
              }}
            >
              Continue
            </Button> */}
          </Space>
        </div>
      </Modal>
    </>
  );
};

export default NewUnlistedProcedureContainer;
